var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLhqLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3386 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448.119 55.6057C446.46 52.7395 443.399 50.9688 440.09 50.9688H192.109C188.792 50.9688 185.731 52.7395 184.08 55.6057L141.98 128.522H333.379C335.938 128.522 338.016 130.6 338.016 133.159V174.216C338.016 176.775 335.938 178.853 333.379 178.853H113.918V177.128L71.9375 249.834H333.372C335.93 249.834 338.009 251.912 338.009 254.471V295.528C338.009 298.087 335.93 300.165 333.372 300.165H71.9375L113.918 372.871V371.146H333.379C335.938 371.146 338.016 373.224 338.016 375.782V416.84C338.016 419.399 335.938 421.477 333.379 421.477H141.98L184.08 494.393C185.738 497.259 188.8 499.03 192.109 499.03H440.09C443.399 499.03 446.468 497.259 448.119 494.393L572.109 279.636C573.767 276.77 573.767 273.229 572.109 270.362L448.119 55.6057Z",
    fill: "url(#paint0_linear_53_19)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M630.973 270.363L477.555 4.63693C475.896 1.77071 472.835 0 469.526 0H162.69C159.381 0 156.313 1.77071 154.662 4.63693L1.24366 270.363C-0.414552 273.229 -0.414552 276.771 1.24366 279.637L154.662 545.363C156.32 548.229 159.381 550 162.69 550H469.526C472.843 550 475.904 548.229 477.555 545.363L630.973 279.637C632.631 276.771 632.631 273.229 630.973 270.363ZM604.246 279.637L598.889 288.911L469.549 512.942L464.191 522.216C462.533 525.082 459.472 526.853 456.163 526.853H176.061C172.745 526.853 169.683 525.082 168.032 522.216L162.675 512.942L33.3274 288.911L27.9702 279.637C26.312 276.771 26.312 273.229 27.9702 270.363L33.3274 261.089L162.675 37.0583L168.032 27.7844C169.691 24.9182 172.752 23.1473 176.061 23.1473H456.163C459.48 23.1473 462.541 24.9182 464.191 27.7844L469.549 37.0583L598.889 261.089L604.246 270.363C605.905 273.229 605.905 276.771 604.246 279.637Z",
    fill: "url(#paint1_linear_53_19)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1995.38 442.083V107.916H2046.98L2198.28 407.013H2199.28V107.916H2231.85V442.083H2180.24L2028.94 142.986H2027.94V442.083H1995.38Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1695.11 331.362V218.637C1695.11 169.539 1702.62 141.483 1720.66 125.451C1737.19 110.421 1764.25 104.409 1813.85 104.409C1867.45 104.409 1894.51 111.423 1911.04 129.459C1926.07 145.992 1932.58 174.048 1932.58 218.637V331.362C1932.58 380.46 1924.57 408.516 1906.53 424.548C1890 439.578 1863.45 445.59 1813.35 445.59C1718.66 445.59 1695.11 423.045 1695.11 331.362ZM1900.02 329.358V220.641C1900.02 145.992 1890 136.473 1813.85 136.473C1737.69 136.473 1727.67 145.992 1727.67 220.641V329.358C1727.67 404.007 1737.69 413.526 1813.85 413.526C1890 413.526 1900.02 404.007 1900.02 329.358Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1593.89 442.083V107.916H1626.46V442.083H1593.89Z",
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.62 309.819V277.755H1526.86V352.404C1526.86 389.979 1519.85 414.027 1504.31 427.554C1489.79 440.58 1466.74 445.59 1418.64 445.59C1361.03 445.59 1333.97 439.077 1317.44 420.039C1302.41 404.007 1295.9 375.951 1295.9 330.861V218.637C1295.9 169.539 1303.41 141.483 1321.45 125.451C1338.48 110.421 1365.04 104.409 1416.64 104.409C1454.21 104.409 1476.76 107.415 1492.79 113.928C1515.84 123.447 1526.86 142.485 1526.86 173.046V206.613H1494.29V194.589C1494.29 144.489 1483.77 136.473 1415.64 136.473C1338.48 136.473 1328.46 145.992 1328.46 220.641V329.358C1328.46 405.009 1337.48 413.025 1421.15 413.025C1486.28 413.025 1494.29 405.51 1494.29 342.885V309.819H1406.62Z",
    fill: "#111111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M832.219 442.083V107.916H864.784V410.019H1007.07V442.083H832.219Z",
    fill: "#111111"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.66 108.083H1238.66V140.083H1057.66V108.083Z",
    fill: "#0F7CBF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.66 108.083H1238.66V140.083H1057.66V108.083Z",
    fill: "url(#paint2_linear_53_19)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.66 259.083H1238.66V291.083H1057.66V259.083Z",
    fill: "#0F7CBF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.66 259.083H1238.66V291.083H1057.66V259.083Z",
    fill: "url(#paint3_linear_53_19)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.66 410.083H1238.66V442.083H1057.66V410.083Z",
    fill: "#0F7CBF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.66 410.083H1238.66V442.083H1057.66V410.083Z",
    fill: "url(#paint4_linear_53_19)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3385.42 389.979V442.083H3132.91V372.444C3133.92 303.306 3151.45 287.274 3241.63 273.747C3321.79 259.719 3323.29 258.717 3323.29 209.118C3323.29 165.03 3314.28 157.515 3260.17 157.515C3202.55 157.515 3195.04 164.028 3195.04 212.625V225.651H3133.92C3134.42 172.044 3135.92 160.521 3145.94 142.986C3161.97 115.932 3194.54 104.91 3261.67 104.91C3357.36 104.91 3385.42 128.958 3385.42 211.623C3385.42 256.212 3377.4 279.258 3357.36 294.789C3343.33 305.811 3323.8 311.823 3273.7 320.841C3198.04 332.865 3196.04 334.869 3195.54 380.961L3195.04 389.979H3385.42Z",
    fill: "#0F7CBF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3385.42 389.979V442.083H3132.91V372.444C3133.92 303.306 3151.45 287.274 3241.63 273.747C3321.79 259.719 3323.29 258.717 3323.29 209.118C3323.29 165.03 3314.28 157.515 3260.17 157.515C3202.55 157.515 3195.04 164.028 3195.04 212.625V225.651H3133.92C3134.42 172.044 3135.92 160.521 3145.94 142.986C3161.97 115.932 3194.54 104.91 3261.67 104.91C3357.36 104.91 3385.42 128.958 3385.42 211.623C3385.42 256.212 3377.4 279.258 3357.36 294.789C3343.33 305.811 3323.8 311.823 3273.7 320.841C3198.04 332.865 3196.04 334.869 3195.54 380.961L3195.04 389.979H3385.42Z",
    fill: "url(#paint5_linear_53_19)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3098.99 397.494L3072.94 435.57L3040.87 413.526C3017.32 438.075 2990.27 445.089 2923.64 445.089C2850.49 445.089 2820.43 437.574 2799.39 412.524C2777.85 387.975 2772.84 362.925 2772.84 285.771C2772.84 197.595 2776.34 173.547 2791.87 148.497C2804.9 128.958 2826.44 114.93 2854 109.419C2867.53 106.413 2893.58 104.91 2924.64 104.91C2971.73 104.91 2995.28 107.916 3013.82 115.932C3043.88 129.459 3060.91 153.507 3067.42 192.585C3069.93 207.615 3070.93 227.655 3070.93 275.25C3070.93 335.37 3069.93 350.901 3064.42 373.446L3098.99 397.494ZM2909.11 323.346L2935.16 284.769L3004.3 331.863C3005.3 319.839 3005.8 312.324 3005.8 307.815V273.747C3005.8 218.136 3005.8 218.136 3003.3 203.106C3000.29 183.567 2992.78 171.042 2979.75 165.531C2968.73 161.022 2956.2 160.02 2918.63 160.02C2878.05 160.02 2864.52 162.525 2854 173.046C2842.98 183.567 2838.47 201.102 2837.97 234.168V289.278C2837.97 336.873 2839.47 349.899 2845.48 365.43C2854 385.971 2867.02 389.979 2932.15 389.979C2962.72 389.979 2969.73 387.975 2986.76 375.951L2909.11 323.346Z",
    fill: "#111111"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2714.92 107.916V442.083H2650.79V299.298H2495.98V442.083H2431.85V107.916H2495.98V244.689H2650.79V107.916H2714.92Z",
    fill: "#111111"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_19",
    x1: 82.0046,
    y1: 212.271,
    x2: 556.436,
    y2: 339.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2621A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F7CBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53_19",
    x1: 12.6933,
    y1: 198,
    x2: 608.687,
    y2: 362.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2621A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F7CBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_53_19",
    x1: 972.213,
    y1: 353.909,
    x2: 1091.51,
    y2: 454.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2621A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F7CBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_53_19",
    x1: 972.213,
    y1: 353.909,
    x2: 1091.51,
    y2: 454.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2621A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F7CBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_53_19",
    x1: 972.213,
    y1: 353.909,
    x2: 1091.51,
    y2: 454.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2621A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F7CBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_53_19",
    x1: 3179.43,
    y1: 124.409,
    x2: 3355.53,
    y2: 406.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2621A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F7CBF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLhqLogoLight);
export default __webpack_public_path__ + "static/media/lhqLogoLight.78e7271aaa52cb933322dda51f947bc1.svg";
export { ForwardRef as ReactComponent };